import {DesktopDatePicker, type DesktopDatePickerProps} from '@mui/x-date-pickers';
import useLanguage from 'hooks/useLanguage';
import 'dayjs/locale/nb';
import {LocalizationComponent} from './LocalizationComponent';

export const InputMenuDatePicker = (props: DesktopDatePickerProps<Date>) => {
  const {dateFormatter} = useLanguage();
  return (
    <LocalizationComponent
      children={
        <DesktopDatePicker
          {...props}
          slotProps={{...props.slotProps, openPickerIcon: {color: 'secondary'}}}
          displayWeekNumber={true}
          format={dateFormatter.getDateFormat()}
        />
      }
    />
  );
};
